export default "__VITE_ASSET__CM1rb6vy__"